/* eslint-disable prettier/prettier */
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
  "gitBuildGlobalVersion": "2.9.2",
  "gitBuildTime": "2026-09-24T20:07:20.701Z",
  "gitBuildVersion": "2.9.2",
  "gitCommitId": "7241bcf",
  "gitCommitIdFull": "7241bcfd74b2a0d62f5546c98cd42507b860caa3",
  "gitCommitTime": "2026-09-24T20:05:48.000Z",
  "version": "2.9.2-2026-09-24T20:05:48.000Z-(7241bcf)"
};
